import {ICampaignStatusEnum} from '../../campaigns/interfaces/ICampaigns';
import OrderLists from '../components/list';

const OrderInProgress = () => {
  return <OrderLists status={ICampaignStatusEnum.IN_PROGRESS} />;
};

export default OrderInProgress;
